import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import mousify from './mousify'
import leftClick from '../left-click'

var Handle = Backbone.View.extend({
  className: 'rotating-handle',

  events: {
    'mousedown': 'listen',
    'touchstart': 'listen'
  },

  initialize: function (opts) {
    this.canvas = opts.canvas
    _.bindAll(this, 'drop', 'drag')
  },

  render: function () {
    let rotateIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235 235" class="rotate-icon"><defs/><path d="M183.3 197.7c-4.4 2.7-8.4 5.5-12.8 7.8-19 10-39.1 13.3-60.3 10.8-18.3-2.1-35-8.5-49.8-19.5a91.3 91.3 0 01-34.2-50.3c-6-22-5.1-44 3.1-65.2a93.1 93.1 0 0173.8-61.8c26-4.8 50.7 0 73.3 13.7 5.6 3.4 10.5 7.9 15.7 11.9l1.8 1.6 33-27.3-7.6 81-80.3-7.5v-.6l32.4-27A64.3 64.3 0 00156.8 54c-26.6-14.6-52.3-11.9-76.7 5.2a70.8 70.8 0 00-25.7 32c-6.9 17-6.7 34.2.2 51.1a75.7 75.7 0 0038 41.3 66.8 66.8 0 0064.3-3c3-1.7 6-3.8 9-5.7l17.4 22.8z"/></svg>`
    this.$el.html('<div class="box">' + rotateIcon + '</div><div class="line"></div>')
    return this
  },

  listen: _.wrap(function (e) {
    e.preventDefault()
    e.stopPropagation()

    $(document).on('mousemove touchmove', this.drag)
    $(document).on('mouseup touchend', this.drop)
    this.$el.trigger('start:rotate')
  }, leftClick),

  drag: function (e) {
    let event = mousify(e)
    this.$el.trigger('drag:rotate', [this.canvas.coords(event)])
  },

  drop: function (e) {
    this.$el.trigger('end:rotate')
    $(document).off('mousemove touchmove', this.drag)
    $(document).off('mouseup touchend', this.drop)
  }

})

var Rotator = Backbone.View.extend({
  className: 'rotator',

  events: {
    'start:rotate': 'start',
    'drag:rotate': 'handleRotate',
    'end:rotate': 'end',
    'gesturestart': 'startWobRotate',
    'gesturechange': 'wobRotate',
    'gestureend': 'endWobRotate',
    'touchmove': 'checkWobRotate'
  },

  initialize: function (options) {
    this.wob = options.wob
    this.canvas = options.canvas

    this.listenTo(this.wob, 'change:locked', function (wob) {
      this.toggle(this.wob.selected && !wob.get('locked'))
    })

    this.listenTo(this.wob, 'change:selected', function (wob, bool) {
      this.toggle(bool && !this.wob.get('locked'))
    })
    this.toggle(this.wob.selected)
  },

  render: function () {
    this.handle = new Handle({canvas: this.canvas})
    this.$el.append(this.handle.render().el)
    return this
  },

  removeHandle: function () {
    if (this.handle) {
      this.handle.remove()
    }

    this.handle = null
  },

  toggle: function (bool) {
    bool ? this.render() : this.removeHandle()
  },

  start: function () {
    var offset = this.$el.offset()
      , area = this.wob.area()
    this.canvas.history.record()
  },

  end: function () {
    this.area = this.wob.area()
  },

  /*
   * Updates the wob with the given rotation angle, snapping to 90 degree increments if necessary
   */
  rotate: function (angle) {
    this.wob.set('rotate', this.snap(angle))
  },

  /*
   * Takes care of rotation via the Handle
   */
  handleRotate: function (e, position) {
    this.rotate(this.angle(this.wob.center(), position))
  },

  /*
   * Setup for a touch rotation
   */
  startWobRotate: function (e) {
    if (this.wob.selected) {
      e.stopPropagation()
      this.startRotation = this.wob.get('rotate')
      this.$el.trigger('start:rotate')
    }
  },

  /*
   * Takes care of rotation via a touch rotate gesture
   */
  wobRotate: function (e) {
    if (this.startRotation !== undefined) {
      e.stopPropagation()
      this.rotate((this.startRotation + e.originalEvent.rotation) % 360)
    }
  },

  /*
   * Fires when touch rotation is done
   */
  endWobRotate: function (e) {
    if (this.startRotation !== undefined) {
      delete this.startRotation
      this.$el.trigger('end:rotate')
    }
  },

  /*
   * Kills the given event (ie touchmove) if a touch rotation is in progress
   */
  checkWobRotate: function (e) {
    if (this.startRotation !== undefined) {
      e.stopPropagation()
    }
  },

  /*
   * Returns the angle between center and mouse coords, `coords`
   */
  angle: function (center, coords) {
    var noon = {
      x: center.x,
      y: center.y - Math.sqrt(Math.abs(coords.left - center.x) * Math.abs(coords.left - center.x) +
          Math.abs(coords.top - center.y) * Math.abs(coords.top - center.y))
    }

    var angle = (2 * Math.atan2(coords.top - noon.y, coords.left - noon.x)) * 180 / Math.PI

    return angle
  },

  /*
   * Snap to the closest 90 degree angle if they are within 2 degrees of it
   */
  snap: function (angle) {
    if (this.close(angle, 90, 2)) { angle = 90 }
    if (this.close(angle, 180, 2)) { angle = 180 }
    if (this.close(angle, 270, 2)) { angle = 270 }
    if (this.close(angle, 0, 2) || angle >= 358) { angle = 0 }
    return angle
  },

  /*
   * Checks if actual and expected are equal, or close enough to be considered equal based on
   * the specificed allowable difference.
   */
  close: function (actual, expected, difference) {
    return actual === expected || Math.abs(actual - expected) <= difference
  },

  release: function () {
    this.removeHandle()
    this.remove()
  }

})

export default Rotator
